import actions from "@/store/funeral/actions";
import state from "@/store/funeral/states";
import mutations from "@/store/funeral/mutations";

const FuneralModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default FuneralModule;